import React, { Component, useState, useEffect } from "react";
import { withTheme } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { Fab, Card } from "@material-ui/core";
import { withRouter } from "react-router";
import { contentClient } from "../../../AxiosClient";
import Pagination from "@material-ui/lab/Pagination";
import { makeStyles } from "@material-ui/core/styles";
import ReusableSection from "./ReusableSection";
import { useTranslation } from "react-i18next";
import AddIcon from "@material-ui/icons/Add";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

import KpsTextField from "../../KpsTextField";
const useStyles = makeStyles((theme) => ({
  root: {
    overflow: "visible",
  },
}));
function ReusableSections(props) {
  const [reusableSections, setReusableSections] = useState([]);
  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState({ titleSearch: "" });
  const [rowsPerPage, setRowsPerPage] = useState(0);
  const [count, setCount] = useState(0);
  const classes = useStyles();
  const { t } = useTranslation();
  // useEffect(() => {
  //   getAllReusableSections();
  // }, []);
  useEffect(() => {
    getAllReusableSections();
  }, [page]);
  useEffect(
    () => {
      getAllReusableSections();
    },
    [filters]
  );
  const getAllReusableSections = () => {
    contentClient
      .get(`/reusablesection/`, {
        params: {
          size: 10,
          page: page,
          ...filters,
        },
      })
      .then((res) => {
        setReusableSections(res.data.content);
        setRowsPerPage(res.data.size);
        setCount(res.data.totalPages);
      });
  };
  const replaceSection = (newSection) => {
    let index = findSectionIndex(newSection);
    let copyReusableSections = [...reusableSections];
    copyReusableSections.splice(index, 1, newSection);
    setReusableSections(copyReusableSections);
  };
  const findSectionIndex = (findSection) => {
    let index = null;
    reusableSections.map((section, idx) => {
      if (section.reusableSectionId === findSection.reusableSectionId) {
        index = idx;
      }
    });
    return index;
  };
  const removeSection = (section) => {
    let index = findSectionIndex(section);
    let newReusableSections = [...reusableSections];
    newReusableSections.splice(index, 1);
    setReusableSections(newReusableSections);
  };
  const removeNew = (id) => {
    for (let i = 0; i < reusableSections.length; i++) {
      if (reusableSections[i].tempId === id) {
        reusableSections.splice(i, 1);
      }
    }
    setReusableSections(reusableSections);
  };
  return (
    <div
      style={{
        width: "100%",
        height: "calc(100% - 64px)",
        display: "flex",
        flexDirection: "row",
        backgroundColor: "#eae0d7",
        backgroundImage: "url('../images/background.svg')",
      }}
    >
      {/* {!props.addSection && <div style={{ width: '25%', height: '100%' }}></div>} */}
      <div style={{ width: "25%", height: "100%" }} />
      <div
        style={{ height: "100%", width: !props.addSection ? "100%" : "50%" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            overflow: "auto",
            height: "calc(100% - 64px)",
          }}
        >
          <Card
            raised
            id="card"
            style={{ margin: "16px", marginBottom: 0 }}
            classes={{
              root: classes.root,
            }}
          >
            <KpsTextField
              onChange={(e) =>
                setFilters({
                  ...filters,
                  titleSearch: e.target.value.toLowerCase(),
                })
              }
              defaultValue={filters.titleSearch}
              label={"Search title"}
              aria-label="Text search for reusable section title"
              style={{ margin: 16, width: "calc(100% - 32px)" }}
            />
          </Card>
          {reusableSections.map((section, idx) => (
            <Card
              aria-label={`Reusable section ${section.title}`}
              raised
              key={
                section.reusableSectionId
                  ? section.reusableSectionId + "-reusable-section"
                  : section.tempId + "-reusable-section"
              }
              id={
                section.reusableSectionId
                  ? section.reusableSectionId + "-reusable-section"
                  : section.tempId + "-reusable-section"
              }
              style={{ margin: "16px" }}
              classes={{
                root: classes.root,
              }}
            >
              <ReusableSection
                {...props}
                onSelected={props.onSelected}
                removeSection={removeSection}
                replaceSection={replaceSection}
                addSectionToList={(section) => {
                  let temp = [...reusableSections];
                  temp.shift();
                  setReusableSections([section, ...temp]);
                }}
                section={section}
              />
            </Card>
          ))}
        </div>
        <Card
          raised
          id="card"
          style={{
            display: "flex",
            flexDirection: "column",
            position: "relative",
            overflowWrap: "anywhere",
            marginLeft: 16,
            marginRight: 16,
            marginBottom: 16,
          }}
          classes={{
            root: classes.root,
          }}
        >
          <Pagination
            style={{ margin: 8, alignSelf: "center" }}
            count={count}
            rowsPerPage={rowsPerPage}
            onChange={(e, page) => setPage(page - 1)}
            color="primary"
          />
        </Card>
      </div>
      {!props.addSection &&
        props.user.userPermits.roles.contentAdmin && (
          <Fab
            onClick={() =>
              setReusableSections([
                { new: true, tempId: new Date().getTime() },
                ...reusableSections,
              ])
            }
            color="primary"
            aria-label="Create reusable section"
            style={{
              position: "absolute",
              bottom: 10,
              right: 10,
            }}
          >
            <AddIcon />
          </Fab>
        )}
      <div style={{ width: "25%", height: "100%" }} />
      {/* {!props.addSection && <div style={{ width: '25%', height: '100%' }}></div>} */}
    </div>
  );
}
const mapStateToProps = (state) => ({
  user: state.user.currentUser,
});
export default connect(
  mapStateToProps,
  null
)(withRouter(withTheme(ReusableSections)));
